import React, { useEffect, useState } from "react";
import RestService from "./../../Restservice";
import GlobalHelmet from "./../../GlobalHelmet";
import "./company.css";
import ScrollableTabsButtonAuto from "./ScrollableTabsButtonAuto";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Breadcrumbs from "./../../component/breadcrumbs";
import Loader from "./../../component/Loader";
import Header from "./Header";
import FAQ from "./FAQ";
import { Helmet } from "react-helmet";
import SaveStock from "./SaveStock";

const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    // width: 200,
  },
}));

function Index() {
  let userParams = useParams();
  const symbol = userParams.symbol;
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  const mobile = userdata.mobile ? userdata.mobile : "";
  const web_token = userdata.web_token ? userdata.web_token : "";

  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [stockName, setStockName] = useState("");
  const [globaldata, setglobaldata] = useState({});
  const [resultdata, setresultdata] = useState({});
  const [fnoData, setFnoData] = useState({});
  const metaData = [
    {
      title: `${symbol} Share/Stock Price Today - Money Tree Robo`,
      description: `Get live ${symbol} Share Price, Technical Analysis, Fundamental Analysis, Fundamental Ranking, Technical Ranking, Valuation Ranking, Delivery Volume of stock`,
      keyword: `share price, ${symbol} share price nse, ${symbol} share price today, ${symbol} share, ${symbol} stock price, ${symbol} screener, ${symbol} share price trend`,
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [symbol]);

  useEffect(() => {
    setLoading(true);
    RestService.gethStockData(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setglobaldata(response.data);
        setresultdata(response.data.response);
        setStockName(
          `${response.data.response?.name?.split(" ")[0]} ${
            response.data.response?.name?.split(" ")[1]
          }`
        );
      },
      symbol,
      mobile,
      web_token
    );
  }, [symbol, mobile, web_token]);

  React.useEffect(() => {
    RestService.gethStockAnalysisData(
      function (res) {
        const response = JSON.parse(res);
        setFnoData(response.data);
      },
      symbol,
      mobile,
      web_token
    );
  }, [symbol, mobile, web_token]);

  const correction = {
    "about-": "",
    "-share-price": "",
    "-market-capitalization": "",
    "-screener": "",
    "-technical-analysis": "",
    "-option-chain": "",
    "-events-data": "",
    "-peers-data": "",
    "-block-deals": "",
    "-bulk-deals": "",
  };
  let newSymbol = symbol;
  Object.keys(correction).forEach((key) => {
    newSymbol = newSymbol.replace(key, correction[key]);
  });

  return (
    <>
      <GlobalHelmet {...metaData} />
      {resultdata && (
        <Helmet>
          <title>{resultdata?.metaTitle}</title>
          <meta property="og:title" content={resultdata?.metaTitle}></meta>
          <meta name="description" content={resultdata?.metaDescription} />
          <meta name="keywords" content={resultdata?.metaKeywords} />
        </Helmet>
      )}

      {loading ? <Loader /> : ""}
      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-sm-12">
              {globaldata?.wathclist && (
                <SaveStock
                  newSymbol={newSymbol}
                  wathclist={globaldata?.wathclist}
                  mobile={mobile}
                  web_token={web_token}
                />
              )}
              <Breadcrumbs
                page={resultdata?.name ? resultdata?.name : ""}
              />

              <div className="mt-2">
                <Header
                  resultdata={resultdata}
                  showType={globaldata?.showType}
                  globaldata={globaldata}
                />
                <p className="mt-2 stock-paragraph">
                  Get <b>{newSymbol}</b> share price nse with today’s gainers
                  and today’s losers. Also get, <b>{newSymbol}</b> share price
                  target with <b>{newSymbol}</b> 52 week high &{" "}
                  <b>{newSymbol}</b> 52 week low share price. Explore{" "}
                  <b>{newSymbol}</b> share price today with market
                  capitalization, technical analysis, intraday screener,
                  fundamental analysis like PE ratio, Earnings, NPM, ROE, EPS,
                  ROCE, EBITDA & debt to equity. Find technical indicators like
                  RSI, Stochastic, MACD, ADX, Moving averages like 5 EMA, 10
                  EMA, 20 EMA etc. Explore pivot point analysis for daily,
                  weekly & monthly data. Explore <b>{newSymbol}</b> share price
                  nse with live stock chart, news, stock performance, delivery
                  volume & volume breakout stocks.
                </p>
                <div className="mt-4">
                  <div className="row">
                    <div className="col-sm-12">
                      <ScrollableTabsButtonAuto
                        value={resultdata}
                        funvalue={
                          globaldata.funDetails ? globaldata.funDetails : ""
                        }
                        funXDetails={
                          globaldata.funXDetails ? globaldata.funXDetails : ""
                        }
                        symbol={symbol}
                        newsLink={globaldata?.newsLink}
                        indicators={globaldata?.indicators}
                        showIndicators={globaldata?.showIndicators}
                        fnoData={fnoData}
                      />
                    </div>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-sm-12">
                    {globaldata?.faqs?.length > 0 && <h3>FAQ</h3>}
                    {globaldata && <FAQ faqs={globaldata?.faqs} />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Index;
